import RedocWrapper from "../../../../../content/api/components/RedocWrapper";
import * as React from 'react';
export default {
  RedocWrapper,
  React
};